import { render, staticRenderFns } from "./SollAcademyVisuzalizador.vue?vue&type=template&id=03a6d604&scoped=true"
import script from "./SollAcademyVisuzalizador.vue?vue&type=script&lang=js"
export * from "./SollAcademyVisuzalizador.vue?vue&type=script&lang=js"
import style0 from "./SollAcademyVisuzalizador.vue?vue&type=style&index=0&id=03a6d604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a6d604",
  null
  
)

export default component.exports